<template>
  <!-- 自定义图片 -->
  <img :src="`${hzUrl}${src}`" />
</template>

<script>
export default {
  components: {},
  props: {
    src: {
      typeof: String,
      default: '',
    },
  },
  data() {
    return {
      hzUrl: 'https://image.hezongyy.com/pcimage/',
    }
  },
  methods: {},
}
</script>



// WEBPACK FOOTER //
// src/components/selfImg.vue